/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";

//*************** Libreria para realizar pdfs************************************* */
import pdfMake from "pdfmake/build/pdfmake";

// ------------------ COMPONENTES DE BASE--------------------------
import Loader from "../../../../Base/Components/Loader/Loader";
import { toastShow } from "../../../../Base/Services/ToastService";
import { formatNumberDecimal } from "../../../../Base/Services/FormatTemplate";

// ------------------- CONSULTAS A LA API---------------------------
import { getInformacionEmpresa } from "../../../../Base/API/Global/InformacionEmpresa/InformacionEmpresaRequest";
import { getAutorizacionesPases, getDetallePorId, getEncabezadoPorId } from "../../../../API/Logistica/PasesSalidaRequest";
import { getFirmaPersonal } from "../../../../API/Payrolls/Firmas/FirmasRequests";

import QRCode from "qrcode";


const PasesSalidaReporte = ({ showReporte, setShowReporte, selectedReporte, setSelectedReporte }) => {
  const [loading, setLoading] = useState(true);
  const [reporte, setReporte] = useState(null);
  const toast = useRef(null);

  const obtenerInformacion = async () => {
    setLoading(true);
    if (selectedReporte) {
      let IdPase = selectedReporte?.IdPase;
      const infoEmpresaTempo = await getInformacionEmpresa();
      
      const encabezado = await getEncabezadoPorId(IdPase);
      const detalles = await getDetallePorId(IdPase);
      let TipoPase
      if(encabezado[0]?.Sale === 'IsActivo'){
        TipoPase = 'Salida de Activo'
      }else if(encabezado[0]?.Sale === 'IsProducto'){
        TipoPase = 'Salida de Procuto'
      }else if( encabezado[0]?.Sale === 'IsIngreso'){
        TipoPase = 'Salida de Ingreso'
      }else if (encabezado[0]?.Sale === 'Otro'){
        TipoPase = 'Otro'
      }
      const autorizaciones = await getAutorizacionesPases()
      let autorizacionesAct = autorizaciones.map(i=> i?.IdPermisoGeneral)
      const ImgBlanco = await getFirmaPersonal('111')
      let FirmaAutorizo
      let FirmaBodega
      let FirmaFinanzas
      let FirmaSeguridad

      if(encabezado[0]?.IdUserAutorizo){
        FirmaAutorizo = await getFirmaPersonal(encabezado[0]?.IdPersonalAutorizo)
      }
      if(encabezado[0]?.IdUserAutorizoBodega){
        FirmaBodega = await getFirmaPersonal(encabezado[0]?.IdPersonalAutorizoBodega)
      }
      if(encabezado[0]?.IdUserAutorizoBodega){
        FirmaFinanzas = await getFirmaPersonal(encabezado[0]?.IdPersonalAutorizoFinanzas)
      }
      if(encabezado[0]?.IdUserAutorizoSeguridad){
        FirmaSeguridad = await getFirmaPersonal(encabezado[0]?.IdPersonalAutorizoSeguridad)
      }

      if (encabezado?.length > 0 && detalles?.length > 0) {
        GenererReporte(encabezado[0], detalles, infoEmpresaTempo[0], TipoPase, autorizacionesAct, ImgBlanco, FirmaAutorizo, FirmaBodega, FirmaFinanzas, FirmaSeguridad);
      } else {
        toastShow(toast, "error", "Error", "No se encontro el Pase de Salida");
        setTimeout(() => {
          onHideReporte();
        }, 600);
      }
    }

    setLoading(false);
  };


  const GenererReporte = ( encabezado, detalles, infoEmpresa, TipoPase, autorizacionesAct, ImgBlanco, FirmaAutorizo, FirmaBodega, FirmaFinanzas, FirmaSeguridad ) => {
    setLoading(true);

    QRCode.toDataURL(`${encabezado.NoPaseSalida}`, { errorCorrectionLevel: "Q" }, (err, Texturl) => {
      if (err) {
        console.error("Error generando QR:", err);
        setLoading(false);
        return;
      }

      const etiquetasCopias = [
        "Original Aduana: Pag. 1",
        "Copia Bo.Suministros: Pag. 2",
        "Copia Seguridad: Pag. 3",
        "Copia Proveedor: Pag 4",
        "Copia Import /Export: Pag. 5",
      ];

      const generarContenidoCopia = (index) => {
        return [
            {
              text: "Pase de Salida",
              style: "tituloReporte",
              margin: [0, 0, 0, 10],
            },
            {
              table: {
                widths: ["10%", "40%", "11%", "39%"],
                body: [
                  [
                    {
                      text: "Solicita:",
                      style: "enunciado",
                      border: [true, false, false, false],
                    },
                    {
                      text: encabezado?.UserNameSolicita || "",
                      style: "encabezado",
                      border: [false, false, false, false],
                    },
                    {
                      text: "Área:",
                      style: "enunciado",
                      border: [true, false, false, false],
                    },
                    {
                      text: encabezado?.Area || "",
                      style: "encabezado",
                      border: [false, false, true, false],
                    },
                  ],
                  [
                    {
                      text: "Destino:",
                      style: "enunciado",
                      border: [true, false, false, false],
                    },
                    {
                      text: encabezado?.CustomerName || "",
                      style: "encabezado",
                      border: [false, false, false, false],
                    },
                    {
                      text: "Dirección:",
                      style: "enunciado",
                      border: [true, false, false, false],
                    },
                    {
                      text: encabezado?.Direccion || "",
                      style: "encabezado",
                      border: [false, false, true, false],
                    },
                  ],
                  [
                    {
                      text: "Motivo:",
                      style: "enunciado",
                      border: [true, false, false, false],
                    },
                    {
                      text: encabezado?.Motivo || "",
                      style: "encabezado",
                      border: [false, false, false, false],
                    },
                    {
                      text: "Explicación:",
                      style: "enunciado",
                      border: [true, false, false, false],
                    },
                    {
                      text: encabezado?.Comentario || "",
                      style: "encabezado",
                      border: [false, false, true, false],
                    },
                  ],
                  [
                    {
                      text: "Motorista:",
                      style: "enunciado",
                      border: [true, false, false, false],
                    },
                    {
                      text:
                        encabezado?.NombreCompletoMotorista +
                          " - " +
                          encabezado?.Identificacion || "",
                      style: "encabezado",
                      border: [false, false, false, false],
                    },
                    {
                      text: "Transporte:",
                      style: "enunciado",
                      border: [true, false, false, false],
                    },
                    {
                      text: encabezado?.VehiculoCompleto || "",
                      style: "encabezado",
                      border: [false, false, true, false],
                    },
                  ],
                ],
              },
            },
            {
              text: [
                {
                  text: "Tipo Pase: ",
                  style: "enunciado",
                },
                {
                  text: TipoPase,
                  style: "encabezado",
                },
              ],
              margin: [0, 20, 0, 0],
            },

            //Activo
            encabezado?.Sale === "IsActivo"
              ? {
                  margin: [0, 10, 0, 0],
                  table: {
                    widths: ["10%", "*", "7%", "7%", "7%", "3%", "9%"],
                    body: [
                      [
                        {
                          text: "Codigo",
                          style: "enunciadoTabla",
                        },
                        {
                          text: "Activo",
                          style: "enunciadoTabla",
                        },
                        {
                          text: "Cantidad",
                          style: "enunciadoTabla",
                        },
                        {
                          text: "Peso",
                          style: "enunciadoTabla",
                        },
                        {
                          text: "Ud",
                          style: "enunciadoTabla",
                        },
                        {
                          text: "Retorna",
                          style: "enunciadoTabla",
                          colSpan: 2,
                        },
                        {},
                      ],
                      ...detalles.map((item) => [
                        {
                          text: item.CodigoActivo || "",
                          style: "detalleTablaCenter",
                        },
                        { text: item.NombreActivo || "", style: "detalleTabla" },
                        {
                          text: formatNumberDecimal(item.Cantidad) || "",
                          style: "detalleTablaRight",
                        },
                        {
                          text: formatNumberDecimal(item.Peso) || "",
                          style: "detalleTablaRight",
                        },
                        {
                          text: item.UnitSimbol || "",
                          style: "detalleTablaCenter",
                        },
                        {
                          text: item.Retorna ? "Sí" : "No",
                          style: "detalleTablaCenter",
                        },
                        {
                          text: item.FechaRetornoTentStr || "N/A",
                          style: "detalleTablaCenter",
                        },
                      ]),
                    ],
                  },
                }
            : null,

            // Ingreso
            encabezado?.Sale === "IsIngreso"
              ? {
                  margin: [0, 10, 0, 0],
                  table: {
                    widths: [
                      "10%",
                      "10%",
                      "*",
                      "12%",
                      "7%",
                      "5%",
                      "4%",
                      "3%",
                      "9%",
                    ],
                    body: [
                      [
                        {
                          text: "Ingreso",
                          style: "enunciadoTabla",
                        },
                        {
                          text: "Producto",
                          style: "enunciadoTabla",
                          colSpan: 2,
                        },
                        {},
                        {
                          text: "Tipo",
                          style: "enunciadoTabla",
                        },
                        {
                          text: "Cant",
                          style: "enunciadoTabla",
                        },
                        {
                          text: "Peso",
                          style: "enunciadoTabla",
                        },
                        {
                          text: "Ud",
                          style: "enunciadoTabla",
                        },
                        {
                          text: "Retorna",
                          style: "enunciadoTabla",
                          colSpan: 2,
                        },
                        {},
                      ],
                      ...detalles.map((item) => [
                        {
                          text: item.NumeroIngreso || "",
                          style: "detalleTablaCenter",
                        },
                        { text: item.CodigoProductoI || "", style: "detalleTabla" },
                        { text: item.NombreProductoI || "", style: "detalleTabla" },
                        {
                          text: item?.NombreCategoriaI || "",
                          style: "detalleTablaRight",
                        },
                        {
                          text: formatNumberDecimal(item.Cantidad) || "",
                          style: "detalleTablaRight",
                        },
                        {
                          text: formatNumberDecimal(item.Peso) || "",
                          style: "detalleTablaRight",
                        },
                        {
                          text: item.UnitSimbol || "",
                          style: "detalleTablaCenter",
                        },
                        {
                          text: item.Retorna ? "Sí" : "No",
                          style: "detalleTablaCenter",
                        },
                        {
                          text: item.FechaRetornoTentStr || "N/A",
                          style: "detalleTablaCenter",
                        },
                      ]),
                    ],
                  },
                }
            : null,

            // PRODUCTO
            encabezado?.Sale === "IsProducto"
              ? {
                  margin: [0, 10, 0, 0],
                  table: {
                    widths: ["10%", "*", "12%", "7%", "5%", "4%", "3%", "9%"],
                    body: [
                      [
                        {
                          text: "Código",
                          style: "enunciadoTabla",
                        },
                        {
                          text: "Producto",
                          style: "enunciadoTabla",
                        },
                        {
                          text: "Tipo",
                          style: "enunciadoTabla",
                        },
                        {
                          text: "Cant",
                          style: "enunciadoTabla",
                        },
                        {
                          text: "Peso",
                          style: "enunciadoTabla",
                        },
                        {
                          text: "Ud",
                          style: "enunciadoTabla",
                        },
                        {
                          text: "Retorna",
                          style: "enunciadoTabla",
                          colSpan: 2,
                        },
                        {},
                      ],
                      ...detalles.map((item) => [
                        { text: item.CodigoProducto || "", style: "detalleTabla" },
                        { text: item.NombreProducto || "", style: "detalleTabla" },
                        {
                          text: item?.NombreCategoria || "",
                          style: "detalleTablaRight",
                        },
                        {
                          text: formatNumberDecimal(item.Cantidad) || "",
                          style: "detalleTablaRight",
                        },
                        {
                          text: formatNumberDecimal(item.Peso) || "",
                          style: "detalleTablaRight",
                        },
                        {
                          text: item.UnitSimbol || "",
                          style: "detalleTablaCenter",
                        },
                        {
                          text: item.Retorna ? "Sí" : "No",
                          style: "detalleTablaCenter",
                        },
                        {
                          text: item.FechaRetornoTentStr || "N/A",
                          style: "detalleTablaCenter",
                        },
                      ]),
                    ],
                  },
                }
            : null,

            // OTRO
            encabezado?.Sale === "Otro"
              ? {
                  margin: [0, 10, 0, 0],
                  table: {
                    widths: ["*", "5%", "5%", "4%", "3%", "9%"],
                    body: [
                      [
                        {
                          text: "Descripción",
                          style: "enunciadoTabla",
                        },
                        {
                          text: "Cant",
                          style: "enunciadoTabla",
                        },
                        {
                          text: "Peso",
                          style: "enunciadoTabla",
                        },
                        {
                          text: "Ud",
                          style: "enunciadoTabla",
                        },
                        {
                          text: "Retorna",
                          style: "enunciadoTabla",
                          colSpan: 2,
                        },
                        {},
                      ],
                      ...detalles.map((item) => [
                        { text: item.Comentario || "", style: "detalleTabla" },
                        {
                          text: formatNumberDecimal(item.Cantidad) || "",
                          style: "detalleTablaRight",
                        },
                        {
                          text: formatNumberDecimal(item.Peso) || "",
                          style: "detalleTablaRight",
                        },
                        {
                          text: item.UnitSimbol || "",
                          style: "detalleTablaCenter",
                        },
                        {
                          text: item.Retorna ? "Sí" : "No",
                          style: "detalleTablaCenter",
                        },
                        {
                          text: item.FechaRetornoTentStr || "N/A",
                          style: "detalleTablaCenter",
                        },
                      ]),
                    ],
                  },
                }
            : null,

              //Linea 1 de firmas
            {
              margin: [35, 40, 35, 0],
              columns: [
                autorizacionesAct.includes(11) ?
                  FirmaAutorizo ?
                  {
                    image:  "data:image/png;base64," + FirmaAutorizo,
                    width: 150,
                    height: 100,
                    border: [false,false,false,false],
                  } :
                  {
                    image:  "data:image/png;base64," + ImgBlanco,
                    width: 150,
                    height: 100,
                    border: [false,false,false,false]
                  }
                : {text: ''},

                { text: ""},
                
                autorizacionesAct.includes(12) ?
                  FirmaBodega ?
                  {
                    image:  "data:image/png;base64," + FirmaBodega,
                    width: 150,
                    height: 100,
                    border: [false,false,false,false],
                  } :
                  {
                    image:  "data:image/png;base64," + ImgBlanco,
                    width: 150,
                    height: 100,
                    border: [false,false,false,false]
                  }
                : {text: ''},
              ],
            },

            {
              margin: [35, -30, 35, 0],
              columns: [
                autorizacionesAct.includes(11) ?
                {
                  text: [
                    {
                      text: '_____________________________\n',
                      style: 'tituloReporte'
                    },
                    {
                      text: 'Firma Solicita\n',
                      style: 'textoFirmas'
                    },
                    {
                      text: encabezado?.UserNameAutorizo || '',
                      style: 'textoFirmasBold'
                    },
                  ],
                  style: "tituloReporte",
                } : {text: ''},

                { text: ""},
                
                autorizacionesAct.includes(12) ?
                {
                  text: [
                    {
                      text: '_____________________________\n',
                      style: 'tituloReporte'
                    },
                    {
                      text: 'Firma Bodega\n',
                      style: 'textoFirmas'
                    },
                    {
                      text: encabezado?.UserNameAutorizoBodega || '',
                      style: 'textoFirmasBold'
                    },
                  ],
                  style: "tituloReporte",
                } : {text: ''},
              ],
            },

            //Linea 2 de firmas
            {
              margin: [35, 10, 35, 0],
              columns: [
                autorizacionesAct.includes(13) ?
                  FirmaFinanzas ?
                  {
                    image:  "data:image/png;base64," + FirmaFinanzas,
                    width: 150,
                    height: 100,
                    border: [false,false,false,false],
                  } :
                  {
                    image:  "data:image/png;base64," + ImgBlanco,
                    width: 150,
                    height: 100,
                    border: [false,false,false,false]
                  }
                : {text: ''},

                { text: ""},
                
                autorizacionesAct.includes(10) ?
                  FirmaSeguridad ?
                  {
                    image:  "data:image/png;base64," + FirmaSeguridad,
                    width: 150,
                    height: 100,
                    border: [false,false,false,false],
                  } :
                  {
                    image:  "data:image/png;base64," + ImgBlanco,
                    width: 150,
                    height: 100,
                    border: [false,false,false,false]
                  }
                : {text: ''},
              ],
            },
            
            {
              margin: [35, -30, 35, 0],
              columns: [
                autorizacionesAct.includes(13) ?
                {
                  text: [
                    {
                      text: '_____________________________\n',
                      style: 'tituloReporte'
                    },
                    {
                      text: 'Firma Finanzas\n',
                      style: 'textoFirmas'
                    },
                    {
                      text: encabezado?.UserNameAutorizoFinanzas || '',
                      style: 'textoFirmasBold'
                    },
                  ],
                  style: "tituloReporte",
                } : {text: ''},

                { text: ""},
                
                autorizacionesAct.includes(10) ?
                {
                  text: [
                    {
                      text: '_____________________________\n',
                      style: 'tituloReporte'
                    },
                    {
                      text: 'Firma Seguridad\n',
                      style: 'textoFirmas'
                    },
                    {
                      text: encabezado?.UserNameAutorizoSeguridad || '',
                      style: 'textoFirmasBold'
                    },
                  ],
                  style: "tituloReporte",
                } : {text: ''},
              ],
            },
        
        ];
      };

      const contenidoTotal = [];

      for (let i = 0; i < 5; i++) {
        const contenido = generarContenidoCopia(i);
        if (i < 4) contenido.push({ text: "", pageBreak: "after" });
        contenidoTotal.push(...contenido);
      }

      const docDefinition = {
        pageSize: "LETTER",
        pageOrientation: "portrait",
        pageMargins: [38, 105, 38, 60],

        header: function (currentPage, pageCount, pageSize) {
          return {
            table: {
              widths: ["33%", "42%", "*"],
              body: [
                [
                  {
                    image: infoEmpresa?.LogoPrimarioB64,
                    width: 220,
                    rowSpan: 3,
                    margin: [-30, -30, 0, -30],
                  },
                  {
                    text: infoEmpresa?.NombreLegal + `\n`,
                    style: "titulo2",
                    margin: [0, 10, 0, 0],
                  },
                  {
                    image: Texturl,
                    width: 80,
                    margin: [26, -15, 0, -10],
                    rowSpan: 2,
                  },
                ],
                [
                  {},
                  {
                    text: infoEmpresa?.Direccion,
                    style: "titulo3",
                    rowSpan: 2,
                  },
                  {},
                ],
                [
                  {},
                  {},
                  {
                    text: `${encabezado?.NoPaseSalida || ""}`,
                    style: "numeroDoc",
                  },
                ],
              ],
            },
            layout: "noBorders",
            margin: [25, 25, 25, 0],
          };
        },

        footer: function (currentPage, pageCount) {
          const index = Math.min(currentPage - 1, etiquetasCopias.length - 1);

          return {
            margin: [40, 0, 40, 0],
            layout: "noBorders",
            table: {
              widths: ["50%", "50%"],
              body: [
                [
                  {
                    text: "",
                    style: "footer2",
                  },
                  {
                    text: `Fecha Impresión: ${new Date().toLocaleDateString()}`,
                    style: "footer",
                  },
                ],
                [
                  {
                    text: etiquetasCopias[index],
                    style: "footer2",
                  },
                  {
                    // text: `Página ${currentPage} / ${pageCount}`,
                    text: `Página ${currentPage}`,
                    style: "footer",
                  },
                ],
              ],
            },
          };
        },

        content: contenidoTotal,

        styles: {
          titulo: {
            fontSize: 8,
            bold: true,
            alignment: "justify",
          },
          tituloReporte: {
            fontSize: 12,
            bold: true,
            alignment: "center",
          },
          titulo2: {
            fontSize: 11,
            bold: true,
            alignment: "justify",
          },
          titulo3: {
            fontSize: 11,
            alignment: "justify",
          },
          numeroDoc: {
            fontSize: 12,
            color: "red",
            bold: true,
            alignment: "center",
          },
          enunciado: {
            fontSize: 10,
            bold: true,
          },
          enunciadoTabla: {
            fontSize: 8,
            bold: true,
            alignment: "center",
          },
          detalleTabla: {
            fontSize: 8,
            alignment: "justify",
          },
          detalleTablaRight: {
            fontSize: 8,
            alignment: "right",
          },
          detalleTablaCenter: {
            fontSize: 8,
            alignment: "center",
          },
          encabezado: {
            fontSize: 10,
          },
          textoFirmasBold: {
            fontSize: 10,
            bold: true,
            alignment: "center",
          },
          textoFirmas: {
            fontSize: 10,
            alignment: "center",
          },
          footer: {
            fontSize: 9,
            alignment: "right",
          },
          footer2: {
            fontSize: 9,
          },
        },
      };

      const doc = pdfMake.createPdf(docDefinition);
      doc.getDataUrl((url) => {
        setReporte(url);
        setLoading(false);
      });
    });
  };


  useEffect(() => {
    if (showReporte) {
      obtenerInformacion();
    }
  }, [showReporte]);

  const onHideReporte = () => {
    setShowReporte(false);
    setSelectedReporte(null);
  };

  return (
    <Dialog
      visible={showReporte}
      onHide={onHideReporte}
      style={{ width: "63vw", height: "85vh" }}
    >
      <Loader loading={loading} />
      <Toast ref={toast} />
      <div>
        {!loading && reporte && (
          <iframe
            src={reporte}
            style={{ width: "60vw", height: "75vh", border: "1px solid #ccc" }}
            id="foo"
            title="Reporte QR PDF"
          />
        )}
      </div>
    </Dialog>
  );
};

export default PasesSalidaReporte;